import { render, staticRenderFns } from "./app_mobile_section.vue?vue&type=template&id=5b9ad788&scoped=true"
import script from "./app_mobile_section.vue?vue&type=script&lang=js"
export * from "./app_mobile_section.vue?vue&type=script&lang=js"
import style0 from "./app_mobile_section.vue?vue&type=style&index=0&id=5b9ad788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ad788",
  null
  
)

export default component.exports